/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { userInvite } from '../../axios/userInvite'
import type { UserInviteError, UserInviteRequest, UserInviteResponse } from '../../types/UserInvite'

export const userInviteMutationKey = () => [{ url: '/users/invite' }] as const

export type UserInviteMutationKey = ReturnType<typeof userInviteMutationKey>

export type UserInviteVariables = {
	data: UserInviteRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::invite */
export function useUserInvite<TContext = unknown>(
	options?: UseMutationOptions<UserInviteResponse, AxiosError<UserInviteError>, UserInviteVariables, TContext>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: userInviteMutationKey(),
		mutationFn: ({ data }: UserInviteVariables) => userInvite(data, config).then(res => res.data),
		...options,
	})
}
